<template>
  <mdb-modal v-show="value" @close="$emit('input', false)">
    <mdb-modal-header  color="grey lighten-4" class="d-flex align-items-center justify-content-between" textColor="grey darken-4">
        <b class="ml-3 mb-0">Post-Completion Quality Assessment</b>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-container>
          <mdb-row>
            <mdb-col>
              <mdb-list-group v-if="reviews !== null">
                <mdb-list-group-item v-for="(review, i) in reviews" :key="i">
                  <span>({{ review.rating_stars }} stars)</span> {{ review.comment }}
                </mdb-list-group-item>
              </mdb-list-group>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import Apicall from '@/libs/Apicall';
import {
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTextarea,
} from 'mdbvue';

export default {
  components: {
    mdbCol,
    mdbContainer,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbRow,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    taskId: {
      type: Number,
      required: true,
    },
    employeeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reviews: null,
    };
  },
  methods: {
    getAll() {
      const api = new Apicall();
      api.call('GET', `api/review-comment?taskId=${this.taskId}&employeeId=${this.employeeId}`).then((response) => {
        if (response.status === 'OK') {
          console.log(response.data);
          this.reviews = response.data;
        } else {
          this.$emit('error', response.msg);
        }
      }).catch((error) => {
        this.$emit('error', error);
      });
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.taskId = null;
        this.employeeId = null;
      } else {
        this.getAll();
      }
    },
  },
};
</script>
